import css from 'ui/preview/button/button.module.scss'

export function createButton(inner: string): HTMLButtonElement {
  const button = document.createElement('button')
  button.innerHTML = inner
  button.classList.add(css.button!)
  return button
}
